<template>
  <div>
    <div class="tradeelite">
      <div class="header_screen container_wrap br10">
        <div class="header_screen_item">
          <div class="header_screen_item_title">类型</div>
          <div class="header_screen_item_els">
            <div
              class="header_screen_item_el"
              v-for="(item, index) in catelist"
              v-show="index<2"
              :key="index"
              :class="item.class"
              @click="handleNavClick(index, item, catelist)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="star_list container_wrap">
        <div
          class="star_list_item_wrap"
          v-for="(item, index) in personinf"
          :key="index"
        >
          <div class="star_list_item">
            <div class="star_list_item_pic">
              <img :src="item.pics[0].url" alt="" />
            </div>
            <div class="star_list_item_right">
              <div class="star_list_item_right_name">{{ item.title }}</div>
              <div class="star_list_item_right_des">{{ item.desc }}</div>
              <div class="star_list_item_right_star">{{item.cate_ids|filterOne}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var that='';
export default {
  name: "TradeElite",
  data() {
    return {
      personinf: [],
      catelist: [],
      catelist_ids: [],
      catename:[]
    };
  },
  created() {
    that=this;
  },
  mounted() {
    document.title = "行业精英"
    this.getcatelist();
  },
  filters:{
     filterOne(val){
       var i;
       // let that = this
       for (i = 0; i < that.catename.length; i++){
         if(val[0]==that.catename[i].id)
          {
            return that.catename[i].name
          }
       }
     },
  },
  methods: {
    allperson() {
      var i;
      var allinf = [];
      for (i = 0; i < this.catelist_ids.length; i++) {
        this.$api.get(
          "/api/cms/recommendList2",
          {
            cate_ids: this.catelist_ids[i],
          },
          (res) => {
            res.data.forEach((e) => {
              allinf.push(e);
            });
          }
        );
      }
      this.personinf = allinf;
    },
    getall() {
      this.$api.get(
        "/api/cms/personSelect",
        {
          cateidlist: this.catelist_ids,
        },
        (res) => {
          this.personinf = res.data;
        }
      );
    },
    getpersoninf(val) {
      const that = this;
      that.$api.get(
        "/api/cms/recommendList2",
        {
          cate_ids: val,
        },
        (res) => {
          this.personinf = res.data;
        }
      );
    },
    getcatelist() {
      const that = this;
      that.$api.get(
        "/api/cms/cateList",
        {
          parent_id: 1,
        },
        (res) => {
          this.catelist = res.data;
          // this.catelist.unshift({name:"全部", class: "header_screen_item_el_active"})
          var i;
          for (i = 0; i < res.data.length; i++) { 
            this.catelist_ids.push(res.data[i].id);
            this.catename.push({'id':res.data[i].id,'name':res.data[i].name})
          }

          this.getall()

          this.handleNavClick(0, this.catelist[0], this.catelist)

        },
      );
    },
    handleNavClick(index, item, targerArr) {
      if(item.name=="全部"){
        this.allperson()
      }
      targerArr.some((ele) => {
        if (ele.class != "") {
          ele.class = "";
        }
      });
      this.getpersoninf(item.id);
      targerArr[index].class = "header_screen_item_el_active";
    },
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1200px;
  margin: 0 auto;
}
.tradeelite {
  min-height: 600px;
  background: #f8f8f8;
  padding-bottom: 30px;
  overflow: hidden;
  .header_screen {
    height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 13px;
    padding: 0 13px 0 24px;
    box-sizing: border-box;
    .header_screen_item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      cursor: default;
      .header_screen_item_title {
        width: 30px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 41px;
      }
      .header_screen_item_els {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .header_screen_item_el {
          height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          margin-right: 47px;
          //   margin-bottom: 23px;
          &:hover {
            cursor: pointer;
            color: #f56057;
          }
        }
        .header_screen_item_el_active {
          color: #f56057;
        }
      }
    }
  }
  .star_list {
    padding-top: 8px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
    font-size: 0;
    .star_list_item_wrap {
      display: inline-block;
      margin-right: 30px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .star_list_item {
        // flex:25%;
        display: flex;
        flex-direction: row;
        width: 380px;
        height: 140px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 16px;
        margin-top: 47px;
        transition: all 0.3s;
        &:hover {
          transform: scale(1.03);
          cursor: pointer;
        }
        .star_list_item_pic {
          width: 119px;
          height: 146px;
          position: relative;
          margin: 0 24px 0 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: -15px;
            left: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            background: pink;
          }
        }
        .star_list_item_right {
          display: flex;
          flex-direction: column;
          flex: 1;
          box-sizing: border-box;
          .star_list_item_right_name {
            max-width: 100%;
            height: 32px;
            font-size: 22px;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 16px;
          }
          .star_list_item_right_des {
            max-width: 100%;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 13px 0 7px 0;
          }
          .star_list_item_right_star {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
            border-radius: 10px 0px 10px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// TradeElite.vue?5b04569e